import React from 'react';
import './AppModal.css';

type TModal = {
  show: boolean;
};
const AppModal = ({ show }: TModal) => {
  return (
    <>
      {show ? (
        <section className='fixed z-[500000] top-0 left-0 right-0 bottom-0 bg-[#061A1480]'>
          <div className='container w-full h-full flex items-center justify-center'>
            <section className='w-full max-w-[479px] z-10  bg-white rounded-xl '>
              <div className='w-full max-w-[479px] mx-auto space-y-[40px] p-6'>
                <div className='modal-child-div'>
                  <div className='modal-div2'>
                    <b className='text-[13px] text-[#229698]'>Warning</b>
                    <hr className='w-[100%] my-2' />

                    <div className='text-xs text-[grey]'>
                      You already have an active session on a different tab. Please close this tab
                      and proceed to your previous tab to continue
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      ) : null}
    </>
  );
};

export default AppModal;
